var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMessageMinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 34 34"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M1 17C1 25.8366 8.16345 33 17 33C25.8366 33 33 25.8366 33 17C33 8.16345 25.8366 1 17 1C13.9485 1 11.0965 1.85427 8.67006 3.33669M9.32 12.84V11.88C9.32 11.1731 9.89307 10.6 10.6 10.6H24.04C24.7469 10.6 25.32 11.1731 25.32 11.88V19.96C25.32 20.6669 24.7469 21.24 24.04 21.24H15.3205C15.1654 21.24 15.0157 21.2963 14.899 21.3983L12.4107 23.5756C12.2038 23.7567 11.88 23.6097 11.88 23.3348V21.56C11.88 21.3833 11.7367 21.24 11.56 21.24H10.6C9.89307 21.24 9.32 20.6669 9.32 19.96V16.4"
})));
export default SvgMessageMinline;